import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getTagsCount } from "../../../../../utils/tag";

export const useBroadcastTags = () => {
  const channelId = useSelector((state) => state.campaign.create.channelId);
  const companyId = useSelector((state) => state.user.data?.company?.id);

  const [tags, setTags] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let active = true;

    const fetchTags = async () => {
      setIsLoading(true);
      const fetched = await getTagsCount(channelId || null, companyId);
      if (!active) return;
      setTags(Array.isArray(fetched) ? fetched : []);
      setIsLoading(false);
    };

    fetchTags();

    return () => {
      active = false;
    };
  }, [channelId, companyId]);

  return { tags, isLoading };
};
